<template>
  <div class="container mt-5">
    <div class="page-content">
      <h2 class="text-center pb-5 h-title">{{ $t('teams.title') }}</h2>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t('teams.tableHeaders.position') }}</th>
              <th class="th-team">{{ $t('teams.tableHeaders.teamName') }}</th>
              <th>{{ $t('teams.tableHeaders.members') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(team, key) in teams" :key="team.id">
              <td>{{ key + 1 }}</td>
              <td>{{ team.name }}</span>
              </td>
              <td
                v-html="
                  team.members
                    .join(',<br />')
                    .replace(
                      team.leader,
                      team.leader + ' (' + $t('teams.leader') + ')'
                    )
                "
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllTeams } from "../services/TeamService";
import { checkLast } from "../services/CacheService";

export default {
  name: "AllTeams",
  data() {
    return {
      refreshTimer: null,
      refreshLast: -1,
      teams: [],
    };
  },
  methods: {
    getAllTeams() {
      getAllTeams().then((response) => {
        this.teams = response;
      });
    },
    pollData() {
      this.polling = setInterval(() => {
        checkLast().then((response) => {
          if (response.last == undefined) {
            return;
          }
          if (this.refreshLast == -1) {
            this.refreshLast = response.last;
          } else if (this.refreshLast != response.last) {
            this.refreshLast = response.last;
            this.getAllTeams();
          }
        });
      }, 15000);
    },
  },
  mounted() {
    this.getAllTeams();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  created() {
    this.pollData();
  },
};
</script>
